import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var filter; // Variable to hold filter data
        var filter2 = {
            // Object to hold additional filter parameters
            dateFrom: '',
            dateTo: '',
            ComissionsPayment: '',
            ComissionsType: '',
        };
        var vthis = this; // Reference to the current instance
        const url = devConfig.geturlApi() + '/Financial/QueryComissions'; // API endpoint for fetching commissions

        // Event listener for filtering the table
        this.on(this.app, 'filter:table', (data) => {
            filter = data; // Store the filter data
        });

        // Event listener for report filtering
        this.on(this.app, 'report:filter', (filterData) => {
            filter2.dateFrom = filterData.Datepicker.split(' - ')[0]; // Set start date
            filter2.dateTo = filterData.Datepicker.split(' - ')[1]; // Set end date
            filter2.ComissionsPayment = filterData.ComissionsPayment; // Set payment type
            filter2.ComissionsType = filterData.ComissionsType; // Set commission type
        });

        // Return the layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Define columns for the datatable
                                {
                                    id: 'detailTittle',
                                    header: "<span placeholder='Aprobar' class='webix_icon wxi-close paycheck'></span>",
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return ''; // Template for detail title column
                                    },
                                },
                                {
                                    id: 'ch1',
                                    header: { content: 'masterCheckbox' }, // Checkbox header
                                    checkValue: 'on', // Value when checked
                                    uncheckValue: 'off', // Value when unchecked
                                    width: 40,
                                    hidden: !devConfig.getPermAction('payCommisionsBetshop', 'Edit'), // Hide if no permission
                                    css: 'prm-payCommisionsBetshop', // CSS class for styling
                                    template: function (obj, type, value) {
                                        if (obj.State == 'A') {
                                            // Check if the state is active
                                            if (value == 'on') {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox" checked="true">`
                                                ); // Return checked checkbox
                                            } else {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox">`
                                                ); // Return unchecked checkbox
                                            }
                                        } else {
                                            return ``; // Return empty if not active
                                        }
                                    },
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // User ID header
                                    width: 100,
                                    sort: 'int', // Sort by integer
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre usuario'), // User name header
                                    width: 250,
                                    sort: 'int', // Sort by integer
                                },
                                {
                                    id: 'UserType',
                                    header: _('Tipo de usuario'), // User type header
                                    width: 200,
                                    sort: 'int', // Sort by integer
                                },
                                {
                                    id: 'PagoComisiones',
                                    header: _('Pago de comisiones'), // Payment of commissions header
                                    width: 150,
                                    options: [
                                        // Options for payment type
                                        { id: 'S', value: _('Saldo') },
                                        { id: 'F', value: _('Factura') },
                                    ],
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // State header
                                    width: 100,
                                    options: [
                                        // Options for state
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Pagada') },
                                    ],
                                },
                                {
                                    id: 'ComissionTotal',
                                    header: _('Total'), // Total header
                                    format: webix.i18n.priceFormat, // Format for price
                                    exportType: 'number', // Export type
                                    width: 150,
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                paycheck: function (euv, id) {
                                    var gridData = $$('datatable').data.pull; // Get data from the datatable
                                    var size = $$('datatable').getPager().config.size; // Get page size
                                    var page = $$('datatable').getPage(); // Get current page
                                    var first = size * page; // Calculate first index
                                    var last = first + size - 1; // Calculate last index
                                    var arrayCheckeds = []; // Array to hold checked user IDs
                                    var gridDataPage = Object.values(gridData).filter(
                                        function (currentValue, index, array) {
                                            return index >= first && index <= last; // Filter current page data
                                        },
                                    );
                                    gridDataPage.forEach(function (currentValue, index, array) {
                                        if (currentValue.ch1 == 'on' && currentValue.State == 'A') {
                                            // Check if checkbox is on and state is active
                                            arrayCheckeds.push(currentValue.UserId); // Add user ID to checked array
                                        }
                                    });
                                    if (arrayCheckeds.length > 0) {
                                        // If there are checked items
                                        let params = {
                                            // Parameters for the API call
                                            Ids: arrayCheckeds,
                                            dateFrom: filter2.dateFrom,
                                            dateTo: filter2.dateTo,
                                            ComissionsPayment: filter2.ComissionsPayment,
                                            ComissionsType:
                                                filter2.ComissionsType === 'ALL' ? '' : filter2.ComissionsType,
                                        };
                                        if (devConfig.getPermAction('payCommisionsBetshop', 'Pay')) {
                                            // Check for payment permission
                                            webix.confirm({
                                                type: 'confirm-warning',
                                                text:
                                                    _('Advertencia!') +
                                                    '<br/>' +
                                                    _('Desea pagar las comisiones seleccionadas?'), // Confirmation message
                                                ok: _('Pagar Comisiones'), // OK button text
                                                cancel: _('Salir'), // Cancel button text
                                                callback: function (action) {
                                                    if (action === true) {
                                                        // If confirmed
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'Financial/PaymentComissionsResume2',
                                                                params,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message('Error! '); // Error message
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        console.log(resp); // Log response
                                                                        if (!resp.HasError) {
                                                                            // Check for errors in response
                                                                            if (resp.CodeError === 300024) {
                                                                                // Specific error handling
                                                                                webix.alert({
                                                                                    type: 'alert-error',
                                                                                    title: 'Error',
                                                                                    text: _(
                                                                                        'El usuario tiene comisión compuesta',
                                                                                    ), // Error message
                                                                                });
                                                                            } else {
                                                                                webix.message(
                                                                                    _(
                                                                                        'Comisiomes pagadas satisfactoriamente',
                                                                                    ),
                                                                                ); // Success message
                                                                                $$('datatable').clearAll(); // Clear datatable
                                                                                $$('datatable').load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        $$('datatable').data
                                                                                            .$pagesize +
                                                                                        filter,
                                                                                ); // Reload datatable
                                                                            }
                                                                        } else {
                                                                            webix.alert({
                                                                                type: 'alert-error',
                                                                                title: 'Error',
                                                                                text: _('Error! '), // General error message
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    }
                                                },
                                            });
                                        } else {
                                            webix.message({
                                                text: _('No tiene permitido esta acción'), // No permission message
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                            });
                                        }
                                    } else {
                                        webix.alert({
                                            type: 'alert-error',
                                            title: 'Error',
                                            text: _('Seleccione por lo menos una comisión para aprobar'), // No selection message
                                        });
                                    }
                                },
                            },
                            on: {
                                // Event handlers for loading events
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch strategy
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + '/Financial/QueryComissions'; // API endpoint for fetching commissions
        this.on(this.app, 'report:filter', (filterData) => {
            if (filterData.ComissionsType === 'ALL') {
                filterData.ComissionsType = ''; // Reset commission type if 'ALL'
            }
            console.log(filterData); // Log filter data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other parameters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add date to query string
                                string1 = string1 + '&dateTo=' + date; // Add date to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object type
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then((response) => {
                // Load new data
                var json = response.json(); // Parse response JSON
                if (json.HasError) {
                    // Check for errors in response
                    if (json.CodeError === 300025) {
                        webix.alert({
                            type: 'alert-error',
                            title: 'Error',
                            text: _('Rango de Fechas Obligatorio'), // Date range required error
                        });
                    } else {
                        webix.alert({
                            type: 'alert-error',
                            title: 'Error',
                            text: _('Error! '), // General error message
                        });
                    }
                } else {
                    grid.clearAll(); // Clear grid data
                    grid.parse(json.data); // Parse and load new data into grid
                }
            });
            this.app.callEvent('filter:table', [string1]); // Trigger filter event
            $$('filterPopup').hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
